import React, { useState, useEffect } from 'react';
import { analytics } from '../services/analytics';

interface CookieConsentProps {
  onAccept?: () => void;
  onDecline?: () => void;
}

export const CookieConsent: React.FC<CookieConsentProps> = ({ onAccept, onDecline }) => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (!analytics.hasConsent()) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    analytics.grantConsent();
    setShowBanner(false);
    onAccept?.();
  };

  const handleDecline = () => {
    analytics.revokeConsent();
    setShowBanner(false);
    onDecline?.();
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t border-stitch-border bg-stitch-footer-bg p-4 text-stitch-footer-fg shadow-stitch-pop">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 sm:flex-row">
        <div className="flex-1">
          <p className="text-sm text-stitch-footer-muted">
            We use cookies and analytics to improve your experience.
            <a
              href="/privacy-policy"
              className="ml-1 font-medium text-stitch-primary underline hover:text-stitch-primary-hover dark:text-stitch-primary"
            >
              Learn more
            </a>
          </p>
        </div>

        <div className="flex flex-shrink-0 gap-3">
          <button
            type="button"
            onClick={handleDecline}
            className="rounded-stitch-lg border border-stitch-border px-4 py-2 text-sm text-stitch-footer-muted transition hover:bg-stitch-surface-2/20"
          >
            Decline
          </button>
          <button
            type="button"
            onClick={handleAccept}
            className="rounded-stitch-lg bg-stitch-primary px-4 py-2 text-sm font-medium text-white hover:bg-stitch-primary-hover"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};
